import React, {Component} from 'react';
import {connect} from "react-redux";
import {Form, Errors, actions} from 'react-redux-form'
import {Row, Col, Button, Panel, FormGroup} from 'react-bootstrap';
import PageTitle from '../../../common/page-title';
import BackLink from '../../../common/back-link';
import RequiredInput from '../../../common/form/elements/required-input';
import ArrowButton from '../../../common/button-arrow';
import Select from '../../../common/form/filtered-dropdown';
import {getPointsDetails, addManualPoints} from "../../../../actions/points";
import {getCustomerNumbers} from "../../../../actions/outlet";
import {isRrfFormValid} from '../../../../utils/commonFunctions';

class ManualPointsTransactions extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    this.props.dispatch(getCustomerNumbers());
  }

  componentWillUnmount() {
    this.props.dispatch(actions.reset('deep.user_point'));
    this.props.dispatch({type: 'CLEAR_POINTS_DETAILS'})
  }

  onSubmit = (payload) => {
    this.props.dispatch(actions.submitFields('deep.user_point', addManualPoints(payload)));
  };

  handleSelectChange = (event) => {
    this.props.dispatch(getPointsDetails(event.label));
  };

  render() {
    let value = this.props.selectedOutlet !== undefined ? {
      value: this.props.selectedOutlet.id,
      label: this.props.selectedOutlet.attributes.name
    } : {
      value: '',
      label: ''
    };

    return (
      <div className="container-fluid">
        <PageTitle>Add manual points transactions</PageTitle>
        <Col md={12}>
          <Row>
            <BackLink href="/admin/points-transactions"/>
          </Row>
          <Row>
            <p>Please note any points added here will be awarded as individual reward points.</p>
          </Row>
        </Col>
        <Col md={12}>
          <Row>
            <Form
              model="deep.user_point"
              onSubmit={this.onSubmit}>

              <Errors className="errors" model="deep.user_point"/>

              <Row>
                <Col lg={12}>
                  <RequiredInput
                    label="Value (points)"
                    placeholder="0"
                    model="deep.user_point.value"
                    controlId="value"/>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <RequiredInput
                    label="Description"
                    placeholder="Description"
                    model="deep.user_point.description"
                    controlId="description"/>
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <FormGroup controlId="outlet">
                    <label>Customer number</label>
                    <Select
                      placeholder="Select Outlet"
                      onChange={this.handleSelectChange}
                      data={this.props.outlets.map((value) => {
                          return {
                            value: value.attributes['customer-number'],
                            label: value.attributes['customer-number']
                          }
                        })}
                      value={value}
                      isLoading={!this.props.fetched}
                      model="deep.user_point.customer_number"/>

                    <Errors
                      show={{touched: true, focus: false}}
                      className="errors"
                      model=".customer_number"/>
                  </FormGroup>
                </Col>
              </Row>
              <Col md={3}>
                <Row>
                  Owner name:<br/>
                  Opted in to PPC?:
                </Row>
              </Col>
              <Col md={9}>
                <Row>
                  {this.props.name}
                  <br/> {this.props.ppc}
                </Row>
              </Col>
              <Col md={12}>
                <Row>
                  <ArrowButton className="float-right"
                               disabled={this.props.form.$form.pending || !isRrfFormValid(this.props.form, {async: false})}>Process</ArrowButton>
                </Row>
              </Col>
            </Form>
          </Row>
        </Col>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const newState = {
    outlets: state.customer_numbers.outlets,
    fetched: state.customer_numbers.fetched,
    form: state.deep.forms.user_point
  };

  if (state.points.details !== null) {
    newState.ppc = state.points.details.ppc;
    newState.name = state.points.details.owner_name
  }

  return newState;
};

export default connect(mapStateToProps)(ManualPointsTransactions);



// WEBPACK FOOTER //
// ./src/components/admin/points/manual-points-transactions/index.jsx